import React from "react";
const SvgNearbyCar = props => (
  <svg fill="none" viewBox="0 0 29 28" {...props}>
    <path
      fill="#1A1F24"
      fillRule="evenodd"
      d="M22.492 10.599h2.025c.306 0 .907 1.773-1.248 1.835l.65 1.656c.053.136.08.28.08.426 0 1.09-.006 2.186-.011 3.281-.006 1.17-.012 2.339-.012 3.502 0 .49-.354.868-.813.868h-2.778c-.436 0-.813-.378-.813-.868V19.35H9.083v1.95c0 .49-.353.867-.812.867H5.515c-.459 0-.812-.378-.812-.868 0-1.163-.006-2.332-.012-3.502a741.235 741.235 0 01-.012-3.288c0-.141.026-.281.076-.414l.63-1.66c-2.118-.063-1.553-1.836-1.247-1.836h2.048l1.33-3.194c.79-1.194 1.39-1.572 2.344-1.572h8.959c.977 0 1.554.378 2.366 1.572l1.307 3.194zm-14.688-.18c-.172.409-.34.807-.511 1.198h14.116c-.171-.39-.339-.79-.511-1.198-.265-.63-.54-1.284-.855-1.97-.294-.528-.623-1.019-1.224-1.082h-8.96c-.576.063-.93.554-1.2 1.082-.315.686-.59 1.34-.855 1.97zm.112 4.748a.583.583 0 000 1.166h2.334a.583.583 0 100-1.166H7.916zm10.5 0a.583.583 0 000 1.166h2.334a.583.583 0 100-1.166h-2.334z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNearbyCar;
